// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const Heading = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.heading"
        description="Heading."
        defaultMessage="My Lenses is currently down for maintenance."
    />
);
Heading.displayName = "Heading";

export const SubHeading = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.subHeading"
        description="Sub heading."
        defaultMessage="Please check back soon."
    />
);
SubHeading.displayName = "SubHeading";

export const Home = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.home" description="Home." defaultMessage="Home" />
);
Home.displayName = "Home";

export const Lenses = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.lenses" description="Lenses." defaultMessage="Lenses" />
);
Lenses.displayName = "Lenses";

export const LensFolders = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.lensFolders"
        description="Lens folders."
        defaultMessage="Lens Folders"
    />
);
LensFolders.displayName = "LensFolders";

export const Welcome = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.welcome" description="Welcome." defaultMessage="Welcome" />
);
Welcome.displayName = "Welcome";

export const DigitalGoods = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.digitalGoods"
        description="Digital goods."
        defaultMessage="Digital Goods"
    />
);
DigitalGoods.displayName = "DigitalGoods";

export const LensInsights = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.lensInsights"
        description="Lens insights."
        defaultMessage="Lens Insights"
    />
);
LensInsights.displayName = "LensInsights";

export const Insights = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.insights" description="Insights." defaultMessage="Insights" />
);
Insights.displayName = "Insights";

export const Monetization = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.monetization"
        description="Monetization."
        defaultMessage="Monetization"
    />
);
Monetization.displayName = "Monetization";

export const Apis = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.apis" description="Apis." defaultMessage="APIs" />
);
Apis.displayName = "Apis";

export const CommunityAudience = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.communityAudience"
        description="Community audience."
        defaultMessage="Community Audience"
    />
);
CommunityAudience.displayName = "CommunityAudience";

export const DigitalGoodsEligibility = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.digitalGoodsEligibility"
        description="Digital goods eligibility."
        defaultMessage="Digital Goods"
    />
);
DigitalGoodsEligibility.displayName = "DigitalGoodsEligibility";

export const AssetLibraryTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.assetLibraryTitle"
        description="Asset library title."
        defaultMessage="Asset Library Assets"
    />
);
AssetLibraryTitle.displayName = "AssetLibraryTitle";

export const LensScheduler = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.lensScheduler"
        description="Lens scheduler."
        defaultMessage="Lens Scheduler"
    />
);
LensScheduler.displayName = "LensScheduler";

export const Apps = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.apps" description="Apps." defaultMessage="Apps" />
);
Apps.displayName = "Apps";

export const CameraKit = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.cameraKit" description="Camera kit." defaultMessage="Camera Kit" />
);
CameraKit.displayName = "CameraKit";

export const HostedLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.hostedLenses"
        description="Hosted lenses."
        defaultMessage="Hosted WebAR Lenses"
    />
);
HostedLenses.displayName = "HostedLenses";

export const RemoteAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.remoteAssets"
        description="Remote assets."
        defaultMessage="Remote Assets"
    />
);
RemoteAssets.displayName = "RemoteAssets";

export const InviteTeamMembers = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.inviteTeamMembers"
        description="Invite team members."
        defaultMessage="Invite Team Members"
    />
);
InviteTeamMembers.displayName = "InviteTeamMembers";

export const PrivacyPolicy = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.privacyPolicy"
        description="Privacy policy."
        defaultMessage="Privacy Policy"
    />
);
PrivacyPolicy.displayName = "PrivacyPolicy";

export const TermsOfService = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.termsOfService"
        description="Terms of service."
        defaultMessage="Terms of Service"
    />
);
TermsOfService.displayName = "TermsOfService";

export const Global = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.global" description="Global." defaultMessage="Global" />
);
Global.displayName = "Global";

export const WebLenses = (): ReactElement => (
    <FormattedMessage id="apps.layout.components.webLenses" description="Web lenses." defaultMessage="Web Lenses" />
);
WebLenses.displayName = "WebLenses";
